/* =============================================================================
 * Delta Clothing — checkout guard
 *
 * Intercepts every "go to checkout" click / form submit on the storefront and
 * pre-flights two conditions before letting Shopify's hosted checkout open:
 *
 *   1. A payment method has been picked (radio in sessionStorage).
 *   2. The cart subtotal does not exceed the customer's remaining credit
 *      (GET /api/customer-limits/:id).
 *
 * Failure modes intentionally fail open. If the limit API hiccups we log and
 * let the customer proceed — never trap them inside a modal because of a
 * transient network failure.
 *
 * Ported from new-ella sections/main-cart.liquid (lines 170-307).
 *
 * Depends on window.B2B (b2b-config.js).
 * =============================================================================*/
(function () {
  if (!window.B2B || window.__dlc_guard_installed) return;
  window.__dlc_guard_installed = true;

  var B2B = window.B2B;
  var FAIL_OPEN = true;

  /* ---- modal ---- */
  function ensureLimitModal() {
    if (document.getElementById('dlc-limit-modal')) return;
    var css = '#dlc-limit-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.45);display:none;z-index:99998}' +
              '#dlc-limit-modal{position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);background:#fff;border-radius:8px;box-shadow:0 20px 50px rgba(0,0,0,.2);width:min(520px,90%);padding:22px 22px 16px;display:none;z-index:99999;font:inherit;color:#111}' +
              '#dlc-limit-modal.open,#dlc-limit-backdrop.open{display:block}' +
              '#dlc-limit-modal h3{margin:0 0 8px;font-size:18px}' +
              '#dlc-limit-modal p{margin:0 0 14px;line-height:1.5}' +
              '#dlc-limit-modal .dlc-actions{display:flex;justify-content:flex-end;gap:8px}' +
              '#dlc-limit-modal .dlc-btn{padding:10px 14px;border-radius:6px;cursor:pointer;border:1px solid #111;background:#fff;color:#111}' +
              '#dlc-limit-modal .dlc-btn-primary{background:#111;color:#fff}';
    var s = document.createElement('style'); s.textContent = css; document.head.appendChild(s);
    document.body.insertAdjacentHTML('beforeend',
      '<div id="dlc-limit-backdrop"></div>' +
      '<div id="dlc-limit-modal" role="dialog" aria-modal="true" aria-labelledby="dlc-limit-title">' +
        '<h3 id="dlc-limit-title">Notice</h3>' +
        '<p class="dlc-limit-message">You cannot proceed to checkout because your purchasing limit has been reached. Please contact our accounting department.</p>' +
        '<div class="dlc-actions"><button id="dlc-limit-close" type="button" class="dlc-btn dlc-btn-primary">OK</button></div>' +
      '</div>');
    document.addEventListener('click', function (ev) {
      if (ev.target.id === 'dlc-limit-close' || ev.target.id === 'dlc-limit-backdrop') {
        document.getElementById('dlc-limit-modal').classList.remove('open');
        document.getElementById('dlc-limit-backdrop').classList.remove('open');
      }
    }, true);
  }

  function showLimitModal(msg, title) {
    ensureLimitModal();
    try { if (title) document.getElementById('dlc-limit-title').textContent = title; } catch (e) {}
    if (msg) document.querySelector('#dlc-limit-modal .dlc-limit-message').textContent = msg;
    document.getElementById('dlc-limit-modal').classList.add('open');
    document.getElementById('dlc-limit-backdrop').classList.add('open');
  }

  /* ---- totals helpers ---- */
  function getCartTotalFromDOM() {
    var el = document.querySelector('[data-cart-total-value]');
    var v  = el ? parseFloat(el.getAttribute('data-cart-total-value')) : NaN;
    if (!isNaN(v) && v > 0) return v;
    var sum = 0, found = false;
    document.querySelectorAll('[data-price]').forEach(function (n) {
      var p = parseFloat(n.getAttribute('data-price'));
      if (!isNaN(p)) { sum += p; found = true; }
    });
    if (found) return sum;
    var sumTxt = 0, hit = false;
    document.querySelectorAll('[data-item-price-with-quantity-display], .cart-item-total, .totals__subtotal-value, [class*="line-price"]').forEach(function (n) {
      var t = (n.getAttribute && n.getAttribute('data-item-price-with-quantity-display')) || n.textContent || '';
      var m = String(t).replace(/[^\d.,]/g, '').replace(',', '.');
      var val = parseFloat(m);
      if (!isNaN(val)) { sumTxt += val; hit = true; }
    });
    return hit ? sumTxt : NaN;
  }

  function getCartTotalAmount() {
    var v = getCartTotalFromDOM();
    if (!isNaN(v) && v >= 0) return Promise.resolve(v);
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (json) { return (json && typeof json.total_price === 'number') ? (json.total_price / 100) : 0; })
      .catch(function () { return 0; });
  }

  function checkLimit(customerId, amount) {
    return B2B.get(B2B.endpoints.customerLimits(customerId))
      .then(function (r) {
        var d = (r && r.data) || {};
        if (r.status === 404 || d.error === 'Customer not found' || /not found/i.test(String(d.message || ''))) {
          return { status: 'NO_POLICY', data: d };
        }
        if (!r.ok) throw new Error('Limit API error ' + r.status);
        var remaining = parseFloat(d.remainingLimit);
        if (isNaN(remaining)) return { status: 'NO_POLICY', data: d };
        return { status: (amount <= remaining) ? 'ALLOWED' : 'BLOCKED', data: d, remaining: remaining, amount: amount };
      });
  }

  /* ---- intent matching ---- */
  function isCheckoutIntent(el) {
    if (!el) return false;
    if (el.matches && el.matches('[name="checkout"],[data-checkout],[data-action="checkout"],.checkout,.cart__checkout,.cart__checkout-button,.mini-cart__checkout,.cart-popup__cta-button--checkout,.invoiceUrl')) return true;
    if (el.getAttribute && el.getAttribute('href') && (/\/checkout/.test(el.getAttribute('href')) || /\/checkouts\//.test(el.getAttribute('href')))) return true;
    var txt = (el.textContent || '').toLowerCase();
    return txt.indexOf('checkout') >= 0 || txt.indexOf('proceed to checkout') >= 0;
  }

  function isCheckoutForm(form) {
    if (!form) return false;
    var act = (form.getAttribute('action') || form.action || '');
    if (/\/cart\/(add|change|update)/i.test(act)) return false;
    if (form.querySelector('[name="checkout"],[data-checkout],[data-action="checkout"]')) return true;
    if (form.querySelector('a[href^="/checkout"], a[href*="/checkouts/"], a.invoiceUrl')) return true;
    var ae = document.activeElement;
    if (ae && form.contains(ae) && isCheckoutIntent(ae)) return true;
    return false;
  }

  /* ---- proceed ---- */
  var __origSubmit = HTMLFormElement.prototype.submit;
  var __origRequestSubmit = HTMLFormElement.prototype.requestSubmit;

  function proceed(target) {
    var href = (target.getAttribute && target.getAttribute('href')) || target.href;
    var form = target.closest && target.closest('form');
    if (href && href !== '#' && href !== 'javascript:void(0)') { window.location.assign(href); return; }
    if (form) { __origSubmit.call(form); return; }

    // No valid href on the checkout button — almost always means the
    // /bag fetch hasn't landed yet (page rendered the skeleton then
    // user clicked before the invoiceUrl could be applied). For B2B
    // we MUST NOT fall through to `/checkout` here: the Shopify-native
    // /checkout is empty because all our cart state lives on the
    // DraftOrder (its invoice URL is what the customer actually needs
    // to hit). Force one bag refresh, apply the URL to every checkout
    // surface, then redirect. If the bag still has no invoice URL
    // we tell the customer the cart isn't ready instead of dumping
    // them on an empty Shopify checkout page.
    if (window.__dlc_bag && typeof window.__dlc_bag.load === 'function') {
      var stop = false;
      var fallback = setTimeout(function () {
        if (stop) return;
        stop = true;
        showLimitModal('Cart is loading. Please wait a moment and try again.', 'Cart Loading');
      }, 5000);

      window.__dlc_bag.load(true).then(function (lines) {
        if (stop) return;
        stop = true;
        clearTimeout(fallback);
        var inv = (lines || []).find(function (l) { return l && l.invoiceUrl; });
        if (inv && inv.invoiceUrl) {
          document.querySelectorAll('.invoiceUrl,[data-checkout-href]').forEach(function (a) {
            a.setAttribute('href', inv.invoiceUrl);
          });
          window.location.assign(inv.invoiceUrl);
        } else {
          showLimitModal('Your cart has no checkout link yet. Please refresh the page and try again.', 'Cart Error');
        }
      }).catch(function () {
        if (stop) return;
        stop = true;
        clearTimeout(fallback);
        showLimitModal('Could not load your cart. Please refresh and try again.', 'Cart Error');
      });
      return;
    }

    // No bag client available (theme-API down? script failed to
    // load?). Refuse to send the customer to the empty Shopify
    // /checkout — that's the path that historically dropped people
    // onto a blank "your cart is empty" page.
    showLimitModal('Cart is not ready yet. Please refresh and try again.', 'Cart Error');
  }

  function runGuard(thenProceed) {
    // Payment method selection (required before checkout)
    var pm = '';
    try {
      pm = (sessionStorage.getItem('__dlc_payment_method') || '').trim();
      var pending = (sessionStorage.getItem('__dlc_payment_pending') || '').trim();
      if (!pm) {
        showLimitModal('Please select a payment method to proceed to checkout.', 'Payment Method Required');
        return;
      }
      if (pending === '1') {
        showLimitModal('Updating your payment method. Please try again in a moment.', 'Please Wait');
        return;
      }
    } catch (e) {}

    var customerId = document.body && document.body.getAttribute('customer');
    if (!customerId) { thenProceed(); return; }

    // Purchase-limit gating only applies to Cash on Hand (Net-30 / on-account
    // sales add to the unpaid balance). Credit Card and PayPal settle the
    // invoice immediately at checkout, so they don't grow the open balance
    // and are explicitly allowed even when the customer is over their
    // limit. See Trello card 8pGojNCY (2026-05-22) and the matching
    // limit-aware UI lock in b2b-payment-fee.js.
    var skipLimitCheck = (pm === 'credit_card' || pm === 'paypal');
    if (skipLimitCheck) { thenProceed(); return; }

    getCartTotalAmount().then(function (total) {
      return checkLimit(customerId, total);
    }).then(function (r) {
      if (r.status === 'BLOCKED') {
        var msg = 'Your Cash on Hand limit is full (Available: $' + r.remaining.toFixed(2) +
                  ', Cart total: $' + r.amount.toFixed(2) + '). ' +
                  'Switch the payment method to Credit Card or PayPal to continue, ' +
                  'or contact our accounting department.';
        showLimitModal(msg, 'Purchase Limit Reached');
      } else {
        thenProceed();
      }
    }).catch(function (err) {
      console.warn('[dlc-guard] error:', err);
      if (FAIL_OPEN) thenProceed();
      else showLimitModal('Could not verify your purchase limit. Please refresh and try again.', 'Limit Check Failed');
    });
  }

  function onCheckoutAttempt(ev) {
    var target = ev.target && ev.target.closest && ev.target.closest('a,button,[role="button"],input[type="submit"]');
    if (!target) return;
    if (!isCheckoutIntent(target) && !((target.closest && target.closest('form')) && isCheckoutForm(target.closest('form')))) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
    runGuard(function () { proceed(target); });
  }

  ['click', 'mousedown', 'mouseup', 'pointerdown', 'pointerup', 'touchstart', 'touchend', 'submit'].forEach(function (evt) {
    document.addEventListener(evt, onCheckoutAttempt, true);
  });

  HTMLFormElement.prototype.submit = function () {
    var form = this;
    if (isCheckoutForm(form)) { runGuard(function () { __origSubmit.call(form); }); return; }
    return __origSubmit.apply(form, arguments);
  };
  if (__origRequestSubmit) {
    HTMLFormElement.prototype.requestSubmit = function (submitter) {
      var form = this;
      if (isCheckoutForm(form) || (submitter && isCheckoutIntent(submitter))) {
        runGuard(function () { __origRequestSubmit.call(form, submitter); });
        return;
      }
      return __origRequestSubmit.apply(form, arguments);
    };
  }

  window.__dlc_guard_patch_ok = true;
})();
